import React from 'react';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import { FeatureTypography } from '../Typography/FeatureTypography';

export const CardTransportDetails = ({featureTransport}) => {

  const {properties: {
    route_color, 
    route_long_name, 
    route_text_color,
    route_short_name,
    route_desc
  } = {}} = featureTransport;

  const styles = {
    card: {
      display: 'flex',
      width: '90%',
      paddingX: '.2em',
    },
    cardContent: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    },
    container: {
      display: 'flex', 
      width: '100%'
    },
    headerContainer: {
      alignItems: 'center'
    },
    numberLine: {
      display: 'flex',
      alignItems: 'center',
      juftifyContent: 'center',
      padding: '.6em',
      backgroundColor: route_color,
      color: route_text_color,
    },
    labelRoute: {
      fontSize: '.9em'
    },
    descSection: {
      display: 'flex'
    },
    descRoute: {
      fontSize: '.8em'
    }
  };


  return (
    <Card sx={styles.card}>
      <CardContent sx={styles.cardContent}>
        <Stack sx={styles.container} spacing={2} direction='column'>
          <Stack sx={styles.headerContainer} direction='row' spacing={2}>
            <Box sx={styles.numberLine}>
              {route_short_name}
            </Box>
            {route_long_name && (
              <Box>
                <FeatureTypography component='p' sx={styles.labelRoute}>{route_long_name}</FeatureTypography>
              </Box>
            )}
          </Stack>
          {route_desc && (
            <Box sx={styles.descSection}>
              <FeatureTypography component='p' sx={styles.descRoute}>{route_desc}</FeatureTypography>
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};